import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 22,
	viewBox: "0 0 13 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.9369 20.984L11.9367 20.9841C11.8536 21.0619 11.7443 21.1 11.6416 21.1C11.543 21.1 11.4379 21.0641 11.3713 20.978L1.03429 11.2634C0.942131 11.2017 0.9 11.1001 0.9 11.0005C0.9 10.898 0.94366 10.7919 1.02774 10.7132C1.02778 10.7132 1.02783 10.7132 1.02788 10.7131L11.3776 0.986569L11.3776 0.986568L11.3779 0.986291C11.4472 0.921706 11.5514 0.9 11.6416 0.9C11.7351 0.9 11.8388 0.922998 11.9214 0.974631L11.9298 0.979857L11.937 0.986616L12.4019 1.42411L12.4795 1.49715L12.4017 1.56996L2.48157 10.8515C2.45621 10.8912 2.4413 10.9461 2.4413 11.0005C2.4413 11.0612 2.45931 11.0982 2.47325 11.1112L2.47339 11.1113L12.4017 20.4012L12.4795 20.4741L12.4018 20.5471L11.9369 20.984Z",
		fill: "#272525",
		stroke: "#272525",
		strokeWidth: .2
	})
});
export { SvgArrowBack as ReactComponent };
